import { I18n } from '@ies/starling_intl';
import React, { useState, useEffect, useMemo } from 'react';
import { useHistory, useLocation, Link, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { Menu, Icon, message } from 'antd';
import { Button, Modal, Popover } from '@arco-design/web-react';
import defaultProjectLogo from '@/assets/images/noPictures.jpg';
import { api } from '@/apis';
import { useCommonModel } from '@/models';
import API from '@/pages/appStoreReview/apple/service/base';
import { IconPlus } from '@arco-design/web-react/icon';
import { IconFont } from './IconFont';
import { handleAccessibleRoutes } from './utils';
import { LeaveCaseModal } from './LeaveCaseModal';
import { baseURL } from '@/common/const';

interface NavProps {
  collapsed: boolean;
  selectKey: string;
}

/** 游戏 LOGO */
export const ProjectLogo: React.FC<{ collapsed: boolean }> = ({
  collapsed,
}) => {
  // const projectID = Number(/\/(\d+)\//.exec(location.pathname)?.[1] || 0);
  const { pathname } = useLocation();
  const [{ userInfo, projectInfo }] = useCommonModel();
  const match = useRouteMatch('/:projectID');
  const history = useHistory();

  const projectID = useMemo(() => {
    if (match === null) {
      return 0;
    } else if ((match.params as any).projectID !== undefined) {
      try {
        return Number((match.params as any).projectID);
      } catch {
        return 0;
      }
    } else {
      return 0;
    }
  }, [pathname]);
  const [data, setData] = useState({
    logoURL: defaultProjectLogo,
    name: 'Cgame',
    star: 0,
    tags: [],
    merged: false,
    commonProjectId: 0,
    gfProjectId: 0,
    proj_type: 0,
    editable: false,
  });
  const [jumpTipsVisible, setJumpTipsVisible] = useState(false);

  const getProjTag = (projType: number) => {
    switch (projType) {
      case 6:
        return (
          <Popover
            style={{
              maxWidth: '440px',
            }}
            content={
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}>
                <span>
                  {I18n.t(
                    'the_current_project_has_ceased_operation_or_maintenance__and_the_past_data_of_th',
                    {},
                    '当前项目已停止运营或维护，项目过往数据可继续查看，但无法在该项目空间中进行提单、分配测试任务等大部分Gameflow操作。',
                  )}
                </span>
              </div>
            }
            position="bl">
            <span
              style={{
                color: 'red',
              }}>
              {I18n.t('project_has_stopped', {}, '项目已停止')}
              <IconFont type="icontishi3" />
            </span>
          </Popover>
        );
      case 3:
        return (
          <span
            style={{
              color: '#1890ff',
            }}>
            {I18n.t('non_game_items', {}, '非游戏项目')}
          </span>
        );
      case 4:
        return (
          <span
            style={{
              color: '#1890ff',
            }}>
            {I18n.t('experience_project', {}, '体验项目')}
          </span>
        );
      case 5:
        return (
          <span
            style={{
              color: '#1890ff',
            }}>
            {I18n.t('test_items', {}, '测试项目')}
          </span>
        );
      default:
        return null;
    }
  };
  const jumpSetting = () => {
    history.push(`/${projectID}/setting`);
  };

  useEffect(() => {
    if (
      ![
        '/login',
        '/signout',
        '/',
        '/download',
        '/noPermission/download',
      ].includes(window.location.pathname) &&
      !window.location.pathname.includes('/share') &&
      !window.location.pathname.includes('/summary') && projectID && projectInfo?.id
    ){
      const {
        icon,
        star,
        platform,
        studio,
        stage,
        tags,
        name,
        merged,
        commonProjectId,
        gfProjectId,
        proj_type,
        editable,
      } = projectInfo;
      setData({
        logoURL: icon ? `/v1/storage/files/${icon}` : defaultProjectLogo,
        star,
        platform: {
          pc: I18n.t('end_game', {}, '端游'),
          web: I18n.t('page_tour', {}, '页游'),
          mobile: I18n.t('mobile_games', {}, '手游'),
        }[platform],
        studio,
        tags,
        stage: {
          incubation: I18n.t('incubation', {}, '孵化'),
          public: I18n.t('open_beta', {}, '公测'),
        }[stage],
        name,
        merged,
        proj_type,
        commonProjectId,
        gfProjectId,
        editable,
      })
    }
  }, [projectID , projectInfo]);

  return (
    <div>
      {collapsed ? (
        <div
          style={{
            lineHeight: '53px',
            textAlign: 'center',
            borderBottom: '1px solid #e8e8e8',
          }}>
          <img
            width="35"
            height="35"
            src={data.logoURL}
            style={{
              marginRight: '25px',
            }}
          />
          {data.editable && !userInfo.isBpo ? (
            <Icon
              type="setting"
              style={{
                fontSize: '14px',
                position: 'absolute',
                right: '10px',
                top: '10px',
              }}
              onClick={() => {
                jumpSetting();
              }}
            />
          ) : null}
        </div>
      ) : (
        <LogoWrapper>
          <img width="35" height="35" src={data.logoURL} />
          <div style={{ width: 120 }}>
            <span>{data.name}</span>
            {data?.merged ? (
              <Popover
                style={{
                  maxWidth: '440px',
                }}
                content={
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}>
                    <span>
                      {I18n.t(
                        'the_current_project_space_is_duplicated_with_other_spaces_and_has_been_merged',
                        {},
                        '当前项目空间与其他空间存在重复，已被合并',
                      )}
                      <span
                        style={{
                          color: 'rgb(64, 159, 255)',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          if (data.gfProjectId) {
                            history.push(
                              `/${data.gfProjectId}/operationManagement/quality-dashboard`,
                            );
                          } else {
                            setJumpTipsVisible(true);
                          }
                        }}>
                        {I18n.t(
                          'click_to_go_to_main_project',
                          {},
                          '点击前往主项目',
                        )}
                      </span>{' '}
                    </span>
                    <span>
                      {I18n.t(
                        'the_project_can_still_be_used__and_the_non_main_project_spatial_data_cannot_corr',
                        {},
                        '该项目仍可被使用，非主项目空间数据无法与其他平台对应项目数',
                      )}
                    </span>
                    <span>
                      {I18n.t(
                        'according_to_linkage__it_is_recommended_to_use_the_main_project!',
                        {},
                        '据联动，建议使用主项目！',
                      )}
                    </span>
                    <span>
                      {I18n.t(
                        '(note_the_data_in_each_duplicate_project_are_not_interoperable)',
                        {},
                        '(注：各重复项目中的数据不互通)',
                      )}
                    </span>
                  </div>
                }
                position="bl">
                <span
                  style={{
                    color: 'red',
                  }}>
                  {I18n.t('project_spaces_are_merged', {}, '项目空间被合并')}
                  <IconFont type="icontishi3" />
                </span>
              </Popover>
            ) : null}
            {data.proj_type !== 1 ? getProjTag(data.proj_type) : null}
          </div>
          {data.editable && !userInfo.isBpo ? (
            <Icon
              type="setting"
              style={{
                fontSize: '14px',
                position: 'absolute',
                right: '10px',
                top: '10px',
              }}
              onClick={() => {
                jumpSetting();
              }}
            />
          ) : null}
        </LogoWrapper>
      )}
      <Modal
        visible={jumpTipsVisible}
        footer={null}
        onCancel={() => {
          setJumpTipsVisible(false);
        }}>
        <p>
          {I18n.t(
            'the_main_project_is_abnormal_and_cannot_jump_normally__please_contact_the_platfo',
            {},
            '主项目异常无法正常跳转，请联系平台管理员@刘天宇',
          )}
        </p>
      </Modal>
    </div>
  );
};

const LogoWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 6px;
  padding: 0 17px;
  min-height: 58px;
  border-bottom: 1px solid #e8e8e8;
  img {
    margin-right: 10px;
  }
  > div {
    width: 120px;
    display: flex;
    flex-direction: column;
    span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 2px 0;
    }
  }
  .tipsWrapper {
    background: #ffff;
    p {
      margin-bottom: 0px;
    }
  }
`;
